import { Message, Notification } from "element-ui"

export const useWebSocket = (
    url ,
    onOpened = () => {},
    onMessage = () => {},
    onClosed = () => {},
    options = {}
) => {
    const {
        reconnectInterval = 2000,
        maxReconnectAttempts = 5,
        heartbeat = true,
        heartbeatInterval = 30000,
        heartbeatMsg = "ping",
    } = options
    let reconnectCount = 0;
    let autoReconnect = true
    let ws = null
    let heartbeatTimer = null
    let noticeIns = null
    let reconnectTimer = null

    // 连接状态管理
    const state = {
        CONNECTING: 0,
        OPEN: 1,
        CLOSING: 2,
        CLOSED: 3
    }

    function connect() {
        //清理旧连接
        if (ws) {
            ws.close()
            ws = null
        }
        ws = new WebSocket(url);

        noticeIns = Notification({
            type: "info",
            duration: 0,
            title: reconnectCount ? `尝试第${reconnectCount}次重新连接服务...` : "连接服务...",
        })
        ws.onopen = () => {
            noticeIns && noticeIns.close();
            Notification({
                type: "success",
                duration: 1000,
                title: "服务连接成功"
            })
            console.log("connect ok")
            reconnectCount = 0;
            console.log("hear", heartbeat)
            heartbeat && heartPing();
            onOpened()
        }

        ws.onmessage = (evt) => {
            if (evt.data !== heartbeatMsg) {
                onMessage(evt.data)
            }
        }

        ws.onclose = (e) => {
            clearTimers()
            console.log("连接断开，尝试重连...")
            noticeIns.close();
            scheduleReconnect();
            onClosed(e)
        }

        ws.onerror = () => {
            console.log("websocket error:", e)
            ws.close()
        }
    }

    //重连机制
    function scheduleReconnect() {
        if (!autoReconnect) return;
        if (reconnectCount < maxReconnectAttempts) {
            reconnectCount++
            reconnectTimer = setTimeout(() => connect(), reconnectInterval)
        } else {
            Message({
                type: "warning",
                duration: 0,
                showClose: true,
                dangerouslyUseHTMLString: true,
                message: '<strong>服务连接失败，请&nbsp;<a href="javascript:window.location.reload();">刷新</a>&nbsp;当前页面后重试</strong>'
            })
        }
    }

    //心跳机制
    function heartPing() {
        clearInterval(heartbeatTimer)
        heartbeatTimer = setInterval(() => {
            if (ws.readyState === state.OPEN) {
                ws.send(heartbeatMsg)
            }
        },  heartbeatInterval)
    }

    //资源清理
    function clearTimers() {
        clearInterval(heartbeatTimer)
        clearTimeout(reconnectTimer)
    }

    function close() {
        ws && ws.close()
        autoReconnect = false
        clearTimers()
    }
    connect();

    return {
        send: (data) => {
            if (ws && ws.readyState === state.OPEN) {
                ws.send(data)
            }
        },
        close,
        reconnect: connect
    }
}
